import React from "react";
import * as S from "./styles";

const ModalTitle = ({ children }) => {
  return <S.Title>{children}</S.Title>;
};

export default ModalTitle;
